(function (appSetup) {

	appSetup.componentsFactory = function (appComponents) {

		var components = {};

		components.factories = appComponents;

		components.cookedComponents = {
			controllers: {},
			services: {},
			pageComponents: {},
			prototypes: {}
		};

		components.getComponent = function (componentType, componentName) {
			if (components.cookedComponents[componentType][componentName] == null) {
				components.cookedComponents[componentType][componentName] = components.factories[componentType][componentName](components);
			}
			return components.cookedComponents[componentType][componentName];
		};

		components.getController = function (controllerName) {
			return components.getComponent("controllers", controllerName);
		};

		components.getService = function (serviceName) {
			return components.getComponent("services", serviceName);
		};

		components.getControllerPrototype = function () {
			return components.getComponent("prototypes", "controller");
		};

		components.getComponentPrototype = function () {
			return components.getComponent("prototypes", "component");
		};

		components.getPageComponent = function (controller, pageComponentName) {
			if (components.cookedComponents.pageComponents[controller.name] == null) {
				components.cookedComponents.pageComponents[controller.name] = {};
			}
			if (components.cookedComponents.pageComponents[controller.name][pageComponentName] == null) {
				components.cookedComponents.pageComponents[controller.name][pageComponentName] = components.factories.pageComponents[controller.name][pageComponentName](controller);
			}

			return components.cookedComponents.pageComponents[controller.name][pageComponentName];
		};

		return components;
	};

	window.appSetup = appSetup;

})(window.appSetup || {});